import { useClipboard } from '@chakra-ui/hooks'
import { CheckMarkIcon, LinkIcon } from '@mote/assets/icons'
import { useMoteShare } from '@mote/recipes'
import {
  BackButton,
  Block,
  Dialog,
  IconButton,
  SharePanel,
  SharePanelProvider,
  SharePanelView,
  Text,
  useSharePanelContext
} from '@mote/ui'
import { Tooltip } from '@mote/ui/components/TooltipV2'
import styled from '@xstyled/styled-components'

export interface ShareDialogProps {
  moteId: string
  playbackLocation: string
  isClassroomButtonHidden: boolean
  isDownloadButtonHidden: boolean
  onClose: () => void
  isOpen: boolean
}

export function _ShareDialog(props: ShareDialogProps) {
  const sharePanelContext = useSharePanelContext()
  const moteShare = useMoteShare(props.moteId, props.playbackLocation)
  const { hasCopied, onCopy } = useClipboard(moteShare.moteUrl)

  return (
    <Dialog
      isOpen={props.isOpen}
      onClose={() => {
        props.onClose()
        sharePanelContext.reset()
      }}
      maxWidth={450}
    >
      {/*@ts-expect-error*/}
      <Dialog.Header gap={8}>
        {sharePanelContext.view === 'initial' ? null : (
          //@ts-expect-error
          <BackButton onClick={sharePanelContext.reset} />
        )}
        {sharePanelContext.str()}
      </Dialog.Header>
      {/*@ts-expect-error*/}
      <Dialog.Content>
        <Block minHeight={216}>
          <SharePanel
            variant={'tooltip'}
            isClassroomButtonHidden={props.isClassroomButtonHidden}
            isDownloadButtonHidden={props.isDownloadButtonHidden}
            onEmbedClick={moteShare.handleEmbedClick}
            onClassroomClick={moteShare.handleGoogleClassroomShare}
            onDownloadClick={moteShare.handleDownload}
            onQRCodeClick={moteShare.handleQrCodeGenerator}
            shareLinkButton={
              <>
                <IconButton
                  data-tip
                  data-for={'shareLink'}
                  //@ts-expect-error
                  onClick={() => {
                    onCopy()
                    moteShare.handleCopyLink()
                  }}
                  icon={<LinkIcon />}
                />
                <Tooltip id={'shareLink'}>Share link</Tooltip>
              </>
            }
          />
          <SharePanelView
            onSave={moteShare.handleSaveQRImage}
            onCopy={moteShare.handleCopyLink}
            filename={moteShare.qrCodeFilename}
            url={moteShare.moteUrl}
          />
          {hasCopied && (
            <Notification
              align='center'
              justify='center'
              gap={10}
              layout='horizontal'
              maxWidth={300}
            >
              <CheckMarkIcon color='white' />
              <Text tag='p' fontSize={16} color='white'>
                Link copied to clipboard
              </Text>
            </Notification>
          )}
        </Block>
      </Dialog.Content>
    </Dialog>
  )
}

export function ShareDialog(props: ShareDialogProps) {
  return (
    <SharePanelProvider>
      <_ShareDialog {...props} />
    </SharePanelProvider>
  )
}

const Notification = styled(Block)`
  position: absolute;
  bottom: 27px;
  left: 25px;
  right: 25px;
  background: black;
  box-shadow: xl;
  border-radius: 40px;
  height: 50px;
`
